/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_SendInputs */

const en_us2_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send feedback`)
};

const pt_br2_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar avaliação`)
};

const es_419_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar opinión`)
};

const pt_pt2_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar avaliação`)
};

const fr_fr2_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer l'avis`)
};

const de_de2_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback senden`)
};

const it_it2_workout_after_send = /** @type {(inputs: Workout_After_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia feedback`)
};

/**
* | output |
* | --- |
* | "Send feedback" |
*
* @param {Workout_After_SendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_send = /** @type {((inputs?: Workout_After_SendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_SendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_send(inputs)
	if (locale === "es-419") return es_419_workout_after_send(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_send(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_send(inputs)
	if (locale === "de-DE") return de_de2_workout_after_send(inputs)
	if (locale === "it-IT") return it_it2_workout_after_send(inputs)
	return en_us2_workout_after_send(inputs)
});
export { workout_after_send as "workout-after.send" }